import styles from "./StatCard.module.css";

export type StatTone = "ok" | "warn" | "crit" | "muted";

// One KPI tile: label (with what period it covers on the right), headline
// value, optional one-line detail.
type StatCardProps = {
  readonly label: string;
  readonly value: string;
  readonly scope?: string | undefined;
  readonly sub?: string | undefined;
  readonly tone?: StatTone | undefined;
};

export const StatCard = ({ label, value, scope, sub, tone }: StatCardProps): JSX.Element => (
  <div className={styles.card}>
    <span className={styles.head}>
      <span className={styles.label}>{label}</span>
      {scope != null && <span className={styles.scope} title={scope}>{scope}</span>}
    </span>
    <span className={tone != null ? `${styles.value} ${styles[`tone_${tone}`] ?? ""}` : styles.value}>
      {value}
    </span>
    {sub != null && <span className={styles.sub} title={sub}>{sub}</span>}
  </div>
);
